import Client from './KomodoClient';
import { pagerRows } from './Resource';

// komodo RoleController (api/role) + RoleSecurityController (api/role-security).
const enc = encodeURIComponent;

const list = () => Client.get('/api/role');
const create = (dto) => Client.post('/api/role', dto);
const update = (roleCode, dto) => Client.put(`/api/role/${enc(roleCode)}`, dto);
const remove = (roleCode) => Client.del(`/api/role/${enc(roleCode)}`);

// Users in a role. Save = full replace for the role.
const users = (roleCode) =>
	Client.get(`/api/role-security/user/${enc(roleCode)}`).then(pagerRows);
const saveUsers = (roleCode, userCodes) =>
	Client.put(`/api/role-security/user/${enc(roleCode)}`, {
		recordList: (userCodes || []).map((userCode) => ({ roleCode, userCode })),
	});

// Companies a role applies to. Save replaces the companies the operator has rights to.
const depts = (roleCode) =>
	Client.get(`/api/role-security/dept/${enc(roleCode)}`).then(pagerRows);
const saveDepts = (roleCode, deptCodes) =>
	Client.put(`/api/role-security/dept/${enc(roleCode)}`, {
		recordList: (deptCodes || []).map((deptCode) => ({ roleCode, deptCode })),
	});

// Permission catalogue (gy_functionmenu × gy_navigation, ordered by category / navigation / order)
// and the role's checked function ids. Save = whole-matrix replace.
const functionMenu = () => Client.get('/api/role-security/function-menu');
const functions = (roleCode) =>
	Client.get(`/api/role-security/function/${enc(roleCode)}`).then(pagerRows);
const saveFunctions = (roleCode, functionIds) =>
	Client.put(`/api/role-security/function/${enc(roleCode)}`, {
		roleFunctionList: functionIds || [],
	});

export default {
	list,
	create,
	update,
	remove,
	users,
	saveUsers,
	depts,
	saveDepts,
	functionMenu,
	functions,
	saveFunctions,
};
